import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import {
  Box,
  Button,
  Grow,
  IconButton,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PresetSelector from './PresetSelector';

const StyledDataGridToolbar = ({
  filterState,
  setFilterState,
  placeholder,
  handleOpen,
  buttonTitle,
  setOpenHeatingPanicDialog,
  ...props
}) => {
  const [showToolbar, setShowToolbar] = useState(false);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setFilterState((prevState) => ({
      ...prevState,
      [value]: checked, // Allow both filters to be toggled
    }));
  };

  const { t } = useTranslation('translation');

  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
        background: 'inherit',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GridToolbarQuickFilter
          size="small"
          sx={{
            '& .MuiGridToolbarQuickFilter-root': {
              borderRadius: '5px',
              border: '1px solid blue !important',
            },
            '& .MuiInputBase-root': {
              borderRadius: '5px',
            },
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
              display: 'none',
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
          }}
          variant="standard"
          InputProps={{
            placeholder: t('translation:search'),
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {placeholder !== 'EnergyAssets' && (
          <>
            <Grow in={showToolbar}>
              <GridToolbar />
            </Grow>

            {placeholder === 'Subscriptions' && (
              <>
                <FormControl>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Tooltip title="Show active only" placement="top">
                          <Checkbox
                            checked={filterState?.active}
                            onChange={handleCheckboxChange}
                            value="active"
                          />
                        </Tooltip>
                      }
                      label="Show Paused"
                    />
                    <FormControlLabel
                      control={
                        <Tooltip
                          title="Show predictive heat control only"
                          placement="top"
                        >
                          <Checkbox
                            checked={filterState?.predictiveHeatControl}
                            onChange={handleCheckboxChange}
                            value="predictiveHeatControl"
                          />
                        </Tooltip>
                      }
                      label="PHC"
                    />
                  </FormGroup>
                </FormControl>
                <Tooltip
                  title="Proceed to stop the predictive heat control af selected buildings"
                  placement="top"
                >
                  <Button
                    variant="outlined"
                    startIcon={<NotInterestedIcon />}
                    size="small"
                    sx={{
                      backgroundColor: '#ff4545',
                      border: '1px solid red',
                      mr: 2,
                      color: 'white',
                      '&:hover': {
                        backgroundColor: 'red',
                        border: '1px solid red',
                        color: 'white',
                      },
                    }}
                    onClick={setOpenHeatingPanicDialog}
                  >
                    panic
                  </Button>
                </Tooltip>
              </>
            )}
            <PresetSelector {...props} />

            <Tooltip
              title={showToolbar ? 'Hide Options' : 'Show Options'}
              placement="top"
            >
              <IconButton
                onClick={() => setShowToolbar(!showToolbar)}
                sx={{ borderRadius: 1 }}
              >
                {showToolbar ? <FilterListOffIcon /> : <FilterListIcon />}
              </IconButton>
            </Tooltip>

            <Tooltip title={buttonTitle} placement="top">
              <IconButton onClick={handleOpen} sx={{ borderRadius: 1 }}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Box>
    </GridToolbarContainer>
  );
};

export default StyledDataGridToolbar;
